import { render, staticRenderFns } from "./UpsellPreviewButton.vue?vue&type=template&id=23260f45&"
import script from "./UpsellPreviewButton.vue?vue&type=script&lang=ts&"
export * from "./UpsellPreviewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports